Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SessionSharingButtonView extends Backbone.View
  template: JST["backbone/templates/monitoring/session_sharing_button"]

  events:
    'click .edit-sharing-options-button': 'onClickEditSharingOptions'
    'click .stop-sharing-button': 'onClickStopSharing'
    'click .copy-link-button': 'copyLink'

  initialize: (@options = {}) ->
    @edit = @options.edit
    @url = @options.url

  render: ->
    @$el.html(@template({
      edit: @edit
      url: @url
    }))
    @

  onClickEditSharingOptions: ->
    @trigger('editSharingOptions:clicked')

  onClickStopSharing: ->
    @trigger('stopSharing:clicked')

  copyLink: ->
    input = @$el.find('#session-sharing-url-text-mini')[0]
    input.select()
    document.execCommand("copy")
